/*-----------------------------------------------------------------
- Card
-----------------------------------------------------------------*/
export default {

    title   : 'Tarkhineh, familiar family',
    subtitle: 'Cereals, beans, spices, packaging, prepared food, bread, ready soup, string, flour',
    
    button: {
        content: 'Online shop',
    },

};
